const mapAddress = (data: any) => {
    return {
        id: data.id || "",
        main: data.main || false,
        name: data.name || "",
        city: data.city || "",
        state: data.state || "",
        address: data.address || "",
        zip_code: data.zip_code || "",
        neighborhood: data.neighborhood || "",
        number: data.number || "",
        complement: data.complement || ""
    }
}

const mapToEntity = (data: any): any => {
    return {
        id: data?.id || "",
        area_phone: data?.area_phone || "",
        cpf: data?.cpf || "",
        phone: data?.phone || "",
        name: data?.name || "",
        user_id: data?.user_id || "",
        created_at: data?.created_at || "1992-04-25:23:30:00",
        birthdate: data?.birthdate || "",
        gender: data.gender ?? null,
        address: data.address ? mapAddress(data.address) : null
    };
};
export default {
    mapToEntity,
};
